import { Link } from 'react-router-dom';
import { IconExternalLink, IconRefresh } from '@tabler/icons-react';
import { Badge } from '@/admin/components/ui/badge';
import { Button } from '@/admin/components/ui/button';
import type { AdminChatTraceResponse } from '../../api';
import { formatDateTime, statusVariant } from '../../format';
import { CopyId } from './copy-id';

export function TraceHeader({
  trace,
  loading,
  onRefresh,
}: {
  trace: AdminChatTraceResponse | null;
  loading: boolean;
  onRefresh: () => void;
}) {
  const header = trace?.header;
  return (
    <div className="px-4 lg:px-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="space-y-2">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="text-2xl font-semibold tracking-normal">
              {header?.title || 'Chat trace'}
            </h1>
            {header ? (
              <Badge variant={statusVariant(header.status)}>
                {header.status || '-'}
              </Badge>
            ) : null}
            {header?.activity_status ? (
              <Badge variant="outline">{header.activity_status}</Badge>
            ) : null}
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground">
            <span>
              Session <CopyId value={header?.session_id} label="session id" />
            </span>
            <span>
              Conversation{' '}
              <CopyId value={header?.conversation_id} label="conversation id" />
            </span>
            <span>
              User <CopyId value={header?.user_id} label="user id" />
            </span>
            <span>
              Tenant <CopyId value={header?.tenant_id} label="tenant id" />
            </span>
            <span>
              Agent <CopyId value={header?.agent_id} label="agent id" />
            </span>
          </div>
          {header ? (
            <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground">
              <span>Purpose {header.purpose || '-'}</span>
              <span>Created {formatDateTime(header.created_at)}</span>
              <span>
                Last activity {formatDateTime(header.last_activity_at)}
              </span>
            </div>
          ) : null}
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" asChild>
            <Link to="/chats">
              <IconExternalLink className="size-4" />
              Search
            </Link>
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onRefresh}
            disabled={loading}
          >
            <IconRefresh className="size-4" />
            Refresh
          </Button>
        </div>
      </div>
    </div>
  );
}
